package com.kaihuoy.components.common

import androidx.compose.runtime.*
import com.kaihuoy.components.common.*
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.*

@Composable
fun StyledCheckbox(
    label: String,
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit
) {
    Label(attrs = {
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            marginBottom(12.px)
            cursor("pointer")
            color(KaihuTheme.TextPrimary)
            fontWeight("500")
        }
    }) {
        Input(type = InputType.Checkbox, attrs = {
            this.checked(checked)
            onInput { onCheckedChange(it.target.checked) }
            style {
                width(20.px)
                height(20.px)
                marginRight(12.px)
                cursor("pointer")
                property("accent-color", "#00ACC1")
            }
        })
        Span { Text(label) }
    }
}